import { motion } from 'framer-motion';
import { FileText } from 'lucide-react';
import Navigation from '../components/Navigation';
import Footer from '../components/Footer';
import SEO from '../components/SEO';

const SubmitPage = () => {
  return (
    <div className="min-h-screen bg-[#0B0B0D] flex flex-col">
      <SEO
        title="Submit Details | Subsurface"
        description="Share your product details with Subsurface to scope a Trust Signal Scan, Structured Review or Pre-Release QA Audit."
        path="/submit"
      />
      <Navigation />

      <div className="flex-1 pt-32 pb-24 px-6">
        <div className="max-w-4xl mx-auto">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="text-center mb-12"
          >
            <h1 className="text-5xl md:text-6xl font-bold font-display mb-6">
              Submit Your Details
            </h1>
            <p className="text-lg text-[#A0A0A0] leading-relaxed">
              Share your product details, trust concerns, or request a full review directly.
            </p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2 }}
            className="glass-card p-8 rounded-lg"
          >
            {/* Tally Form Embed */}
            <div className="w-full" style={{ minHeight: '600px' }}>
              <iframe
                src="https://tally.so/embed/0Qxb9A?alignLeft=1&hideTitle=1&transparentBackground=1&dynamicHeight=1"
                loading="lazy"
                width="100%"
                height="600"
                frameBorder="0"
                marginHeight="0"
                marginWidth="0"
                title="Subsurface Submission Form"
                className="rounded-lg"
              ></iframe>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.4 }}
            className="mt-12 text-center"
          >
            <p className="text-sm text-[#A0A0A0] mb-4">Prefer a different route?</p>
            <div className="flex flex-wrap justify-center gap-4">
              <a href="/scan" className="text-sm text-[#FF6A00] hover:text-[#FF6A00]/80 transition-colors">
                Run Scan
              </a>
              <a href="/gateway" className="text-sm text-[#FF6A00] hover:text-[#FF6A00]/80 transition-colors">
                Talk to Gateway
              </a>
              <a href="/" className="text-sm text-[#FF6A00] hover:text-[#FF6A00]/80 transition-colors">
                Return Home
              </a>
            </div>
          </motion.div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default SubmitPage;
